<template>
  <div>
    <div v-if="operators">
      <h3>List of TCPortal Operators</h3>
      <button @click="operatorPage.$refs.operatorStore.getOperators()">Refresh</button>
      <table style="width:600px">
        <tr>
          <th>ID</th>
          
          
          <th>Vehicles</th>
          <th>Drivers</th>
          
          
        </tr>

        <tr v-for="operator in operators" :key="operator.id">
          <!-- <td>{{operator}}</td> -->
          <td>
            <button @click="deleteOperator(operator.id)">X</button>
            
            <button v-if="`${operator.account.isActive}` !== 'true'" @click="activateOperator(operator.id)">Activate</button>
            {{operator.id}}
            <button @click="createVehicle(operator)">Create Vehicle</button>
            <button @click="createDriver(operator)">Create Driver</button>
          </td>
          <td>{{vehicles(operator).map(r=>r.vid)}}</td>
          <td>
            <table>
              <tr>
                <th>id</th>
                <th>badge</th>
                <th>pic</th>
                <th>url</th>
                <th>url</th>
                <th>url</th>
              </tr>
              <tr v-for="driver in operatorStore.driversForOperator(operator)" :key="driver.id">
                
                <td>
                  <button @click="deleteDriver(operator.id, driver.id)">X</button>
                  {{driver.id}}
                </td>
                <td>{{driver.badge}}</td>
                <td>{{driver.pic}}</td>
                <td>{{driver.images.badgeFrontURL}}</td>
                <td>{{driver.images.badgeBackURL}}</td>
                <td>{{driver.images.sgiLetterURL}}</td>
              </tr>
            </table>
          </td>
          <!-- <td>{{operator.ts}}</td> -->
          <!-- <td>{{driverForID(operator.id).first_name}} {{driverForID(operator.id).last_name}}</td> -->
          <td></td>
          <!-- <td>{{driver.firstName}} {{driver.lastName}}</td>
          <td>{{driver.badge}}</td>
          <td>{{driver.username}}</td>
          <td>{{driver.pic}}</td> -->
          
        </tr>
      </table>
      
    </div>
    <div v-else>
      ... Loading
    </div>
  </div>
</template>

<script>
export default {
  name:"Operators",
  inject: ['operatorPage'],
  data(){
    return {
      // baseURL: webpackHotUpdate ? 'http:localhost:8081' : 'https://driver.tcportal.ca'
      baseURL: 'https://driver.tcportal.ca',
    }
  },
  mounted(){
    window.atlDelete = this.deleteDriver
  },
  computed:{
    operators(){
      return this.operatorPage.$refs.operatorStore.operators
    },
    operatorStore(){
      return this.operatorPage.$refs.operatorStore
    },
  },
  methods:{
    createVehicle(operator){
      console.log(operator)
      const headerStr = `Create Vehicle for Operator ${operator.id}\n`
      const car = prompt(`${headerStr}Car Number:`)
      if (!car)
        return
      const areYouSure = confirm(`${headerStr}Create Vehicle ${car}`)
      if (!areYouSure)
        return

      this.operatorPage.$refs.operatorStore.createOperatorVehicle(operator.id, car)
    },
    createDriver(operator){
      console.log(operator)
      const headerStr = `Create Driver for Operator`
      const car = prompt(`${headerStr}Car Number:`)
      if (!car)
        return
      const badge = prompt(`${headerStr}Driver Badge Number:`)
      if (!badge)
        return
      const areYouSure = confirm(`${headerStr}Create Driver ${badge} on vehicle ${car}`)
      if (!areYouSure)
        return

      this.operatorStore.createCredential(operator.id, car, badge, 8675309)
      // this.operatorStore.createOperatorDriver(operator.id.replace("operator_", ''), car, badge)
    },
    deleteDriver(operatorKey, driverKey){
      const areYouSure = confirm(`Are you sure you want to delete driver ${driverKey} on ${operatorKey}`)
      if (!areYouSure)
        return

      this.operatorPage.$refs.operatorStore.deleteOperatorDriver(operatorKey, driverKey);
    },
    deleteOperator(operatorKey){
      const areYouSure = confirm(`Are you sure you want to delete operator ${operatorKey}`)
      if (!areYouSure)
        return

      this.operatorPage.$refs.operatorStore.deleteOperator(operatorKey);
    },
    activateOperator(operatorKey){
      const data = {isActive: "true"}
      this.operatorPage.$refs.operatorStore.updateOperator(operatorKey, data);
    },

    vehicles(operator){
      return this.operatorStore.vehiclesForOperator(operator)
    },

    
  },



  
}
</script>